<template>
    <div class="board_list">
        <ul v-if="data.list.length > 0">
            <li v-for="(post, idx) in data.list || data" :key="post.idx">
                <component
                    :is="isDisclosurePage ? 'a' : 'router-link'"
                    v-bind="
                        isDisclosurePage
                            ? { href: `https://dart.fss.or.kr/dsaf001/main.do?rcpNo=${post.rcept_no}`, target: '_blank' }
                            : { to: { path: `${$route.path}/${post.idx}`, query: $route.query } }
                    "
                >
                    <div class="col">
                        <span v-if="post.noticeYn === 'Y'">
                            <img src="@/assets/ic-fix-post.png" alt="" />
                        </span>
                        <span v-else class="num">
                            {{ ((this.$route.query.page || 1) - 1) * (+this.$route.query.size || 10) + idx + 1 }}
                        </span>
                    </div>
                    <div class="col title">
                        <span>{{ post.title?.trim() || post.subject?.trim() }}</span>
                        <span v-if="post.filename" class="attach-icon">
                            <img src="@/assets/ic-attach.png" alt="" />
                        </span>
                    </div>
                    <div class="col writer" v-if="post.writer && data.noWriter">
                        <span>{{ post.writer }}</span>
                    </div>
                    <div class="col" v-if="post.writeDate">
                        <span class="date">
                            {{ post.date?.toLocaleDateString('ko-KR') || new Date(post.writeDate).toLocaleDateString('ko-KR') }}
                        </span>
                    </div>
                </component>
            </li>
        </ul>
        <p class="no-data" v-else>등록된 게시글이 없습니다.</p>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            default: [],
        },
    },
    data() {
        return {
            path: this.$route.path,
        };
    },
    computed: {
        isDisclosurePage() {
            return this.$route.path.includes('/company/invest/disclosure_information');
        },
    },
};
</script>

<style scoped lang="scss">
.board_list {
    width: 100%;
    border-top: 1px solid var(--black1);

    .no-data {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        min-height: 400px;
        margin-top: 30px;
        color: #999;
    }

    ul {
        width: 100%;

        li {
            list-style: none;
            width: 100%;
            height: 90px;

            border-bottom: 1px solid var(--border-color1);

            @media screen and (max-width: 768px) {
                height: auto;
            }

            &:hover {
                background: #fffbf8;

                .col.title span {
                    color: var(--orange);
                    text-decoration: underline;
                }

                .col.writer span {
                    color: var(--orange);
                    text-decoration: underline;
                }
            }

            a {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 100%;
                height: 100%;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                @media screen and (max-width: 768px) {
                    flex-wrap: wrap;
                    gap: 10px;
                    padding-top: 25px;
                    padding-bottom: 25px;
                }

                .col {
                    &:first-child {
                        width: 100px;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        .num {
                            font-family: 'Play', sans-serif;
                            font-weight: 700;
                            font-size: 18px;
                            color: #888;
                        }

                        @media screen and (max-width: 768px) {
                            display: none;
                        }
                    }

                    &.title {
                        cursor: pointer;
                        display: flex;
                        flex: 1 1 0;
                        align-items: center;
                        gap: 10px;
                        padding-left: 50px;

                        @media screen and (max-width: 768px) {
                            flex: 1 0 auto;
                            width: 100%;
                            margin-right: 0;
                            padding-left: 20px;
                            padding-right: 20px;
                        }

                        > span {
                            text-overflow: ellipsis;
                            overflow: hidden;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            white-space: pre-wrap;
                            word-break: break-all;
                        }

                        p {
                            padding-left: 50px;
                            font-size: 18px;
                            color: var(--black1);
                            letter-spacing: -0.03em;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            overflow: hidden;
                        }

                        .attach-icon {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            flex: none;
                        }
                    }

                    &.writer {
                        margin-left: auto;
                        width: 160px;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        @media screen and (max-width: 768px) {
                            width: auto;
                            font-size: 14px;
                            padding-left: 20px;
                            margin-left: 0;
                        }
                    }

                    &.writer + .col:has(.date) {
                      .date {
                        padding-left: 0 !important;
                      }
                    }

                    &:last-child {
                        margin-left: auto;
                        width: 200px;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        @media screen and (max-width: 768px) {
                            width: auto;
                            margin-left: 0;
                            font-size: 14px;
                        }

                        .date {
                            color: #888;
                            padding-left: 20px;
                        }
                    }
                }
            }
        }
    }
}
</style>
